(function ($) {

    /**
     * Mobile navigation hamburger
     */

    // handle menu icon click
    $('#togglenav').on('click', function() {
        $('header').toggleClass('active');
    });


})(jQuery);